let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jWWrw")).then(() => parcelRequire('5Dvg5'));